import { fitGradient } from "dont-crop";

export function getImageBackground(img) {
    return `${convertColorsToRgba(fitGradient(img), canImageBeTransparent(img.src) ? 0.1 : 0.6)}, #fff`;
}

function canImageBeTransparent(src) {
    const transparentFormats = ['.png', '.gif', '.webp', '.svg', '.tiff'];
    const lowerCaseSrc = src.toLowerCase();
    return transparentFormats.some(format => lowerCaseSrc.endsWith(format));
}

function convertColorsToRgba(gradient, opacity) {
    gradient = gradient.replace(/rgb\((\d+),\s*(\d+),\s*(\d+)\)/g, (match, r, g, b) => {
        return `rgba(${r}, ${g}, ${b}, ${opacity})`;
    });

    gradient = gradient.replace(/#([a-fA-F0-9]{6})/g, (match, hex) => {
        const r = parseInt(hex.substring(0, 2), 16);
        const g = parseInt(hex.substring(2, 4), 16);
        const b = parseInt(hex.substring(4, 6), 16);
        return `rgba(${r}, ${g}, ${b}, ${opacity})`;
    });

    return gradient;
}

